import { Component } from '@angular/core';
import { NavigService } from 'src/app/services/navig.service';

@Component({
  selector: 'app-maison',
  templateUrl: './maison.component.html',
  styleUrls: ['./maison.component.scss']
})
export class MaisonComponent {
  constructor(
    public nav: NavigService
  ){}
}
